// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import Swiper from 'swiper/bundle';
import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

//--------------------------------------------------------------------//

import './slider-news.scss';
const sliderNews = () => {
    let allSliderNews = document.querySelectorAll('.slider-news');

    if (!allSliderNews.length) return;

    allSliderNews.forEach((el, i) => {
        let arrowPrev = el.querySelector('.swiper-button-prev');
        let arrowNext = el.querySelector('.swiper-button-next');

        let pagination = el.querySelector('.swiper-pagination');

        let typePagination = 'bullets';

        if (pagination) {
            switch (true) {
                case pagination.classList.contains('bullets'):
                    typePagination = 'bullets';
                    break;
                case pagination.classList.contains('fraction'):
                    typePagination = 'fraction';
                    break;
                case pagination.classList.contains('progressbar'):
                    typePagination = 'progressbar';
                    break;
                default:
                    typePagination = 'bullets';
                    break;
            }
        }

        let args = {
            slidesPerView: 1,
            breakpoints: {
                0: { spaceBetween: 16, slidesPerView: 1.1 },
                500: { spaceBetween: 16, slidesPerView: 1.7 },
                768: { spaceBetween: 30, slidesPerView: 2.1 },
                800: { spaceBetween: 30, slidesPerView: 2.5 },
                1222: { spaceBetween: 30, slidesPerView: 3.3 },
                1500: { spaceBetween: 30, slidesPerView: 4 },
            },
            spaceBetween: 30,
            navigation: {
                nextEl: arrowNext,
                prevEl: arrowPrev,
            },
            pagination: {
                el: pagination,
                clickable: true,
                dynamicBullets: true,
                type: typePagination,
            },
            a11y: {
                enabled: true,
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
                firstSlideMessage: 'This is the first slide',
                lastSlideMessage: 'This is the last slide',
                paginationBulletMessage: 'Go to slide {{index}}',
                notificationClass: 'swiper-notification',
            },
        };

        new Swiper(el.querySelector('.swiper-container'), args);
    });
};

import './carousel-gallery.scss';
const carouselGallery = () => {
    let allCarousel = document.querySelectorAll('.im-carousel-gallery');

    if (!allCarousel.length) return;

    allCarousel.forEach((el, i) => {
        let arrowPrev = el.querySelector('.swiper-button-prev');
        let arrowNext = el.querySelector('.swiper-button-next');

        let pagination = el.querySelector('.swiper-pagination');

        let typePagination = 'bullets';

        if (pagination) {
            switch (true) {
                case pagination.classList.contains('bullets'):
                    typePagination = 'bullets';
                    break;
                case pagination.classList.contains('fraction'):
                    typePagination = 'fraction';
                    break;
                case pagination.classList.contains('progressbar'):
                    typePagination = 'progressbar';
                    break;
                default:
                    typePagination = 'bullets';
                    break;
            }
        }

        let args = {
            spaceBetween: 0,
            breakpoints: {
                0: { spaceBetween: 16, slidesPerView: 1.1 },
                420: { spaceBetween: 16, slidesPerView: 1.6 },
                700: { spaceBetween: 30, slidesPerView: 1.8 },
                1000: { spaceBetween: 30, slidesPerView: 2 },
                1440: { spaceBetween: 30, slidesPerView: 3 },
                2000: { spaceBetween: 30, slidesPerView: 4 },
                2400: {
                    spaceBetween: 30,
                    slidesPerView: 4.8,
                },
            },

            navigation: {
                nextEl: arrowNext,
                prevEl: arrowPrev,
            },
            pagination: {
                el: pagination,
                clickable: true,
                dynamicBullets: true,
                type: typePagination,
            },
            a11y: {
                enabled: true,
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
                firstSlideMessage: 'This is the first slide',
                lastSlideMessage: 'This is the last slide',
                paginationBulletMessage: 'Go to slide {{index}}',
                notificationClass: 'swiper-notification',
            },
        };

        new Swiper(el.querySelector('.swiper-container'), args);

        lightGallery(el.querySelector('.lightgallery'), {
            thumbnail: true,
            plugins: [lgThumbnail],
            exThumbImage: 'data-exthumbimage',
            animateThumb: true,
            mobileSettings: {
                showCloseIcon: true,
            },
            download: false,
            hideBarsDelay: 1000000000,
            autoplayControls: false,
            hash: false,
            escKey: true,
            keyPress: true,
            licenseKey: 'WQ63Z-598QW-NZ7D5-WPMTB',
        });
    });
};

import './categories.scss';
const categories = () => {
    let allCategoriesSlider = document.querySelectorAll('.categories');
    if (!allCategoriesSlider.length) return;

    const body = document.querySelector('body');

    allCategoriesSlider.forEach((el, i) => {
        let arrowPrev = el.querySelector('.swiper-button-prev');
        let arrowNext = el.querySelector('.swiper-button-next');
        let scrollbar = el.querySelector('.scrollbar');
        let pagination = el.querySelector('.swiper-pagination');

        let typePagination = 'bullets';

        let gap;
        let gap2;

        if (pagination) {
            switch (true) {
                case pagination.classList.contains('bullets'):
                    typePagination = 'bullets';
                    break;
                case pagination.classList.contains('fraction'):
                    typePagination = 'fraction';
                    break;
                case pagination.classList.contains('progressbar'):
                    typePagination = 'progressbar';
                    break;
                default:
                    typePagination = 'bullets';
                    break;
            }
        }

        if (el.classList.contains('header-slider-menu')) {
            gap = 16;
            gap2 = 24;
        } else {
            gap = 8;
            gap2 = 10;
        }

        let args = {
            slidesPerView: 'auto',
            centerInsufficientSlides: true,
            observer: true,
            observeParents: true,
            breakpoints: {
                0: {
                    spaceBetween: gap,
                },
                768: {
                    spaceBetween: gap2,
                },
                scrollbar: {
                    el: scrollbar,
                    hide: false,
                },
            },
            scrollbar: {
                el: scrollbar,
                hide: false,
            },
            navigation: {
                nextEl: arrowNext,
                prevEl: arrowPrev,
            },

            pagination: {
                el: pagination,
                dynamicBullets: true,
                clickable: true,
                type: typePagination,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
                firstSlideMessage: 'This is the first slide',
                lastSlideMessage: 'This is the last slide',
                paginationBulletMessage: 'Go to slide {{index}}',
                notificationClass: 'swiper-notification',
            },
        };

        let swiper = new Swiper(el.querySelector('.swiper-container'), args);
        const links = el.querySelectorAll(".category[href*='#']");

        if (body.classList.contains('page-template-menu-main-page')) {
            const sections = document.querySelectorAll('.menu-list__wrap');

            function changeLinkState() {
                let index = sections.length;

                while (
                    --index &&
                    window.scrollY + 80 < sections[index].offsetTop
                ) {}

                if (index !== -1) {
                    links.forEach((link, i) => {
                        link.classList.toggle('active', i === index);
                    });
                    swiper.slideTo(index);
                }
            }

            changeLinkState();
            window.addEventListener('scroll', changeLinkState);
        } else {
            return;
        }
    });
};

const initSliders = () => {
    sliderNews();
    carouselGallery();
    categories();
};

export default initSliders;
